import { buildCommonTelecomContractParameters } from '../buildCommonTelecomContractParameters'

export const contractSaveParametersGeneration = ({
  type,
  contractId,
  contactId,
  addressId,
  billingAddressId,
  residenceAddressId,
  contractData,
  characteristicsData,
  billingData = {},
  action = 'save',
}) => {
  const options = buildCommonTelecomContractParameters({
    type,
    contractId,
    contactId,
    addressId,
    contractData,
    characteristicsData,
    action,
  })

  options.append('mobile_migration_code', contractData.mobileMigrationCode ?? '')
  options.append('iccid_migration', contractData.iccidMigration ?? '')
  options.append('previous_provider', contractData.previousProvider ?? '')
  options.append('billing_address_id', billingAddressId ?? '')
  options.append('residence_address_id', residenceAddressId ?? '')

  options.append('payment_mode', billingData.paymentMode || '-1')
  options.append('iban', billingData.iban || '')
  options.append('bic', billingData.bic ?? '')

  options.append('owner_name_different', billingData.differentAccountHolder ? 1 : 0)
  options.append('owner_lastname', billingData.accountHolderLastname ?? '')
  options.append('owner_firstname', billingData.accountHolderFirstname ?? '')
  options.append('owner_tax_id_code', billingData.accountHolderTaxIdCode ?? '')

  return options
}
